<template>
  <v-container fluid class="" >
    <v-card class="elevation-2 py-0 px-0 mt-4 rounded-lg d-flex flex-column justify-centers" >
      <v-card-text>
       <span class="display-1">Contact Form</span>
      </v-card-text>
      <v-form ref="form"  lazy-validation class="ml-5 mr-5 w-50 form-width w100 "
              id="id_formEditRuralContact"
      >
        <v-text-field
            v-model="FirstName"
            label="First Name"

        ></v-text-field>

        <v-text-field
            v-model="LastName"
            label="Last Name"

        ></v-text-field>

        <v-select
            :items="ClientSegmentsData"
            item-text="text"
            item-value="value"
            label="Client Segments"
            v-model="selectedItems"
            multiple
        >
        </v-select>
        <v-text-field
            v-model="OtherSegment"
            label="Other Segment"
        ></v-text-field>

        <v-text-field
            v-model="Title"
            label="Title"

        ></v-text-field>

        <v-text-field
            v-model="Address"
            label="Address"

        ></v-text-field>


        <v-text-field
            v-model="CompanyName"
            label="Company"

        ></v-text-field>
        <v-text-field
            v-model="Email"
            :rules="emailRules"
            label="Email"

        ></v-text-field>

        <v-text-field
            v-model="Phone"
            :rules="phoneNumberRules"
            label="Phone Number"

        ></v-text-field>

        <v-text-field
            v-model="Fax"
            :rules="phoneNumberRules"
            label="Fax"

        ></v-text-field>

        <v-text-field
            v-model="linkedin_url"

            label="Linkedin"
        ></v-text-field>
        <v-text-field
            v-model="linkedin_compnay_url"

            label="Linkedin Company"
        ></v-text-field>


        <v-text-field
            v-model="WebsiteCompanyUrl"

            label="Website Company"
        ></v-text-field>


        <v-textarea
            label="Note"
            v-model="Note"
        ></v-textarea>
        <div v-if="isShowMsg_EmalReq" class="mt-5 text-danger">
          <span class="text-danger">Email or Phone Required</span>
        </div>
        <div v-if="ErrorMsgSummary" class="mt-5 text-danger">
          <span class="text-danger">{{ErrorMsgSummary}}</span>
        </div>
        <v-btn class="mr-4 white--text" @click="submit" color="indigo" block :disabled="disabled">
          Save
        </v-btn>
      </v-form>

      <div v-if="isShowAddEvent" class="form-width">
        <RuralEvent4ContactForm :contact_id="this.idContact"
        @endAddedEvents="handler_endCreateEvent"
         ></RuralEvent4ContactForm>
      </div>

      <v-row class="mt-5"></v-row>
    </v-card>

</v-container>
</template>


<script>

// eslint-disable-next-line no-unused-vars
import axios from "axios";
import instance from "@/api/axios-auth";
import RuralEvent4ContactForm from "@/views/Forms/RuralEvent4ContactForm.vue";


export default {
  name: "RuralActivityForm",
  components:{
    RuralEvent4ContactForm
  },
  // props: ['IdContact', 'isEditMode'],
  props: {
    idContact: {
      type: [String, Number],
      default: null,
    },
    isEditMode:{
      type: [Boolean],
      default: false,
    },
    crutchDT:{
      type:Number,
      default:null,
    },
  },
  data(){
    return {
      isShowAddEvent:false,
      selectedItems:null,
      isShowMsg_EmalReq:false,
      ClientSegmentsData: [
        { text: 'Architect/Designer', value: '2' },
        { text: 'Building Official', value: '3' },
        { text: 'Applicators', value: '4' },
        { text: 'General Contractor', value: '5' },
        { text: 'Engineer', value: '6' },
        { text: 'Other', value: '7' },
        //{ text: 'Consulting Management Company', value: '8' },
        { text: 'Fire Marshall', value: '9' },
        //{ text: 'Looks like a competitor checking us', value: '10' },
        { text: 'Retailers', value: '11' },
        { text: 'OEM Companies', value: '12' },
        //{ text: 'Painting Contractor', value: '13' },
        //{ text: 'Insulation Contractor', value: '14' },
        { text: 'Building Owner', value: '15' },
        { text: 'Real Estate', value: '16' },
        // { text: 'Sherwin Williams', value: '17' },
        // { text: 'Individual', value: '18' }
        { text: 'Inspectors', value: '19' },
        { text: 'Research Partners', value: '20' }
      ],
      selectedItem: null,
      items: ['Item 1', 'Item 2', 'Item 3'],

      FirstName:null,
      LastName:null,
      Title:null,
      Address:null,
      linkedin_url:null,
      linkedin_compnay_url:null,
      Fax:null,
      Phone:null,
      Email:null,
      CompanyName:null,
      WebsiteUrl:null,
      WebsiteCompanyUrl:null,
      Note:null,
      OtherSegment:null,

      disabled: false,
      tmp_old_timestamp:-1,

      success: false,
      ErrorMsgSummary:'',
      rules: {
        required: value => !!value || 'This field is required'
      },

      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 30) || 'Name must be less than 10 characters',
      ],
      TitleRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 128) || 'Title must be less than 128 characters',
      ],
      emailRules: [
        v => !v ||(/.+@.+/.test(v) || 'E-mail must be valid'),
      ],
      phoneNumberRules: [
        v => !v || /(^[0-9]{10}$)|(^[0-9]{11}$)|(^\+[0-9]{11,12}$)|(^\+[0-9]{2}\s+[0-9]{2}\s+[0-9]{8}$)|(^[0-9]{3}-[0-9]{3}-[0-9]{4}$)/.test(v) || 'Phone number must be valid',
      ],
      linkedinURLRules: [
        v => !v || /((http(s?):\/\/)?(www\.)?linkedin\.com\/(.*))/i.test(v) || 'URL must be a valid LinkedIn URL or empty',
      ],
      websiteURLRules: [
        v => (v === '')||(!v)|| /^(ftp|http|https):\/\/[^ "]+$/.test(v) || 'Website URL must be valid',
      ],
    }
  },
  mounted() {
    this.loadContactData();

    this.ClientSegmentsData.sort((a, b) => a.text.localeCompare(b.text));
    console.log(this.ClientSegmentsData);
    setInterval(() => {

      if ( this.tmp_old_timestamp != this.crutchDT ){

          this.tmp_old_timestamp = this.crutchDT;
      }
    }, 100);

  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) {
        return
      }
      if (!this.isValidateAdditional()){
        return
      }

      if (!this.idContact){
        return this.submitNew();
      }

      this.disabled = true;
      this.success = false;
      const formdata = this.makeFormPayload();
      console.log(formdata);
      instance.put(`/rural/rural_update_contact/${this.idContact}`,formdata ).then(() => {
        this.success = false;
        this.disabled = false;
        this.$emit('closeModal');
      })
          .catch((error)=>{
            this.disabled = false;
            this.ErrorMsgSummary = error.response.data.toString()

          })
    },
    submitNew(){
      if (!this.$refs.form.validate()) {
        return
      }

      this.disabled = true;
      this.success = false;
      const formdata = this.makeFormPayload();
      // console.log(formdata);
      instance.post(`/rural/rural_create_contact`,formdata ).then(() => {
        this.success = true;
        this.disabled = false;
        this.ErrorMsgSummary = null;
        this.$emit('closeModal');
      }).catch(err => {
        this.disabled = false;
        this.ErrorMsgSummary = err.response.data.toString()
      })

    },
    handler_addEventHandler(){
      this.isShowAddEvent = false;
    },
    makeFormPayload(){
      const res = {
        FirstName: this.FirstName,
        LastName:this.LastName,
        Email:this.Email,
        Fax:this.Fax,
        CompanyName:this.CompanyName,
        Phone:this.Phone,
        Title:this.Title,
        WebsiteUrl:this.WebsiteUrl,
        WebsiteCompanyUrl:this.WebsiteCompanyUrl,
        Address :this.Address,
        LinkidinUrl : this.linkedin_url,
        LinkidinUrlCompany: this.linkedin_compnay_url,
        ClientSegments: this.selectedItems,
        ClientSegmentOther:this.OtherSegment,
        Note:this.Note,

      }

      return res;

    },
    handler_endCreateEvent(){
      this.isShowAddEvent = false;

    },
    loadContactData(){
      if (!this.idContact){ return }
      instance.get("/rural/rural_get_contact/"+this.idContact).then(response => {
        /*
        Address: "625 Swift Blvd\tRichland, Washington 99344"
        Email: "macevedo@ci.richland.wa.us"
        EventsIds: null
        Fax: "509-942-7764"
        Id: 2
        Name: "Mizael Acevedo"
        Organization: "City of Richland"
        Phone: "509-942-7602"
        SegmentIds: null
        Title: "Building Official"
        Website: "http://www.ci.richland.wa.us/"
        * */
        console.log(response)
        this.FirstName = response.data.data.FirstName;
        this.LastName = response.data.data.LastName;
        this.Email = response.data.data.Email;
        this.Fax = response.data.data.Fax;
        this.CompanyName = response.data.data.Organization;
        this.Phone = response.data.data.Phone;
        this.Title = response.data.data.Title;

        this.WebsiteCompanyUrl = response.data.data.CompanyWebsite;
        this.Address = response.data.data.Address;
        this.linkedin_url = response.data.data.LinkedinUrl;
        this.linkedin_compnay_url = response.data.data.LinkedinCompany;
        this.OtherSegment = response.data.data.ClientSegmentOther;
        this.Note = response.data.data.Note;
        console.log(response.data.data.SegmentIds)
        if (response.data.data.SegmentIds){
          this.selectedItems = response.data.data.SegmentIds.map(element => element.toString());
        }
        console.log(this.selectedItems)

      })
    },

    clearData() {
      this.FirstName = null;
      this.LastName = null;
      this.Title = null;
      this.Address = null;
      this.linkedin_url = null;
      this.linkedin_compnay_url = null;
      this.Fax = null;
      this.Phone = null;
      this.Email = null;
      this.CompanyName = null;
      this.WebsiteUrl = null;
      this.WebsiteCompanyUrl = null;
      this.Note = null;
      this.OtherSegment = null;
      this.selectedItems = null;

      this.ErrorMsgSummary = null;
    },

    isValidateAdditional(){
      this.isShowMsg_EmalReq = false;
      if ((!this.Email)&&(!this.Phone)){
        this.isShowMsg_EmalReq = true;
      }
      return !this.isShowMsg_EmalReq;
    },
    

  },// METHODS

  watch: {
    crutchDT(){

      this.clearData();
      this.loadContactData();
    }
  },
}
</script>


<style scoped>
.form-width{
  max-width: 95%;
}
.w100{
  width: 100%;
}
.w80{
  width: 80%;
}
.text-danger {
  color: #dc3545; /* This is the default Bootstrap danger red color */
}
.mt-5{
  margin-top: 20px;
}
.margin-top_skip{
  margin-top: 10px!important;
}
</style>
